module.exports = __webpack_public_path__ + "static/media/thanks.452c858a.png";